import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addSellerLeadNote } from "@/lib/api/seller-leads.api"
import { useAuthStore } from "@/store/auth.store"

export function useAddSellerLeadNote() {
  const { accessToken } = useAuthStore()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: { message: string } }) => {
      if (!accessToken) throw new Error("Not authenticated")
      const response = await addSellerLeadNote(id, payload, accessToken)
      return response.data
    },
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["seller-lead", id] })
    },
  })
}
